<template>
  <div class="sidebar-expanded">
    <div class="sidebar-expanded__top__link is-transparent">
      <router-link
         class="el-button el-button--text"
        :to="backTo.route">
        <i class="el-icon-arrow-left" aria-hidden="true"></i>{{ backTo.label }}
      </router-link>
    </div>

    <div class="sidebar-expanded__top">
      <div class="sidebar-expanded__top__product-information">
        <product-information-card
           icon="fal fa-calendar-alt"
           theme="diet"
          :dividerTitle="$t(dividerTitle)"
          :productDetails="dietDetails.data"
          :fetching="dietDetails.fetching">
        </product-information-card>
      </div>
    </div>
    <!-- end ~ sidebar-expanded__top -->

    <div class="sidebar-expanded__center">
      <div class="sidebar-expanded__menu">
        <el-menu
           ref="menu"
          :router="true"
          :default-active="activeLink"
          :unique-opened="true"
          class="el-menu--nuttrema-navigation-menu"
          @open="handleOpen"
          @close="handleClose">
          <template v-for="navigation in navigations">
            <el-submenu
               v-if="navigation.type === 'section'"
              :index="replaceID(navigation.url)">
              <template slot="title">
                <span>{{ $t(navigation.label) }}</span>
              </template>
              <el-menu-item
                 v-for="(page, childIndex) in navigation.pages"
                :index="replaceID(page.url)"
                :key="replaceID(page.url)"
                :class="[{'is-active': matched(page.name)}, page.class]">
                <span>{{ $t(page.label) }}</span>
              </el-menu-item>
            </el-submenu>

            <el-menu-item
               v-else
              :index="replaceID(navigation.url)"
              :class="[{'is-active': matched(navigation.name)}, navigation.class]">
              <span class="is-title">{{ $t(navigation.label) }}</span>
            </el-menu-item>
          </template>
        </el-menu>
      </div>
    </div>
    <!-- end ~ sidebar-expanded__center -->

    <div class="sidebar-expanded__bottom">
      <nuttrema-status-label
        :id="id"
        :fetching="dietDetails.fetching"
        :available="availableStatuses()"
        :status="_get(dietDetails, 'data.status')"
        :related="_get(dietDetails, 'data.assigned') ? 'program_assigned' : 'program_template'"
        :link="{ name: _get(meta, 'navigation.status') }">
      </nuttrema-status-label>
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import { get } from 'lodash';

import { STATUS_PROGRAM_TEMPLATE, STATUS_PROGRAM_ASSIGNED_SHOW } from 'state-machine/program/status-program';

import ProductInformationCard from 'components/ui/card/product-information-card';
import NuttremaStatusLabel from 'components/ui/label/nuttrema-status-label';

import SidebarMenu from 'components/ui/menu/sidebar-menu';

export default {
  name: 'sidebar-menu-diet-expanded',
  mixins: [
    SidebarMenu,
  ],
  components: {
    ProductInformationCard,
    NuttremaStatusLabel,
  },
  props: {
    id: {
      required: true,
      default: null,
    },
    dayID: {
      required: true,
      default: null,
    },
    dietDetails: {
      type: Object,
      required: true,
      default: null,
    },
  },
  data() {
    return {
      Event,
      startingUrl: '/professional/programs/diets/',
      activeLink: null,
    };
  },
  computed: {
    ProgramDetails() {
      return this.$store.getters.ProgramDetails(this.id);
    },
    dividerTitle() {
      return get(this.ProgramDetails, 'data.assigned') ? 'label.assigned_program' : 'label.program_template';
    },
  },
  methods: {
    replaceID(value) {
      value = value.replace(/{id}/g, this.id);
      value = value.replace(/{dayID}/g, this.dayID);
      return value;
    },
    matched(name) {
      return this.$route.name === name;
    },
    availableStatuses() {
      return get(this.ProgramDetails, 'data.assigned') ? STATUS_PROGRAM_ASSIGNED_SHOW : STATUS_PROGRAM_TEMPLATE;
    },
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        Vue.set(this, 'activeLink', this.$route.path);
      });
    },
  },
  created() {
    Vue.set(this, 'activeLink', this.$route.path);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ui/menu/programs/sidebar-menu-diet-expanded.vue